export const placesDrink = [
  {
    name: "Odette",
    body: "One of our favorite wineries, even though they started selling those weird animal head shaped bottle stoppers. A smaller winery within the Plump Jack group, specializing in cabernets.",
    url: "odetteestate.com/visit"
  },
  {
    name: "Joseph Phelps",
    body: "You may find Richard, clad in cycling spandex, enjoying the estate’s sweeping views. A pricey tasting but well worth it.",
    url: "josephphelps.com"
  },
  {
    name: "Domaine Carneros",
    body: "Enjoy a flight of sparkling wines on the patio of the French-style château. California baroque!",
    url: "domainecarneros.com"
  },
  {
    name: "Ridge",
    body: "The estate tour and tasting brings you to the old-growth vineyards, through the unique facility built of straw and clay, and finishes in the private tasting room.",
    url: "ridgewine.com/visit/lytton-springs"
  },
  {
    name: "Cade",
    body: "Modern architecture and gorgeous views from above the fog line on Howell Mountain.",
    url: "cadewinery.com"
  }
]


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/thingsToDo/placesDrink.ts